module.exports = __webpack_public_path__ + "img/thumbnail_BlackWhiteRuffedLemur_f_normal.8ac8c322.png";